import React, { useContext, useEffect, useState } from "react";
import { Container } from "components/Container";
import { useHistory } from "react-router";
import * as atoms from "./EditarTipoPlanillaStore";
import { useAtom } from "jotai";
import { useModalConfirmar } from "store/global";
import { ModalConfirmar } from "components/Modal/ModalConfirmar";
import {TipoPlanillaEditar} from "./tipoPlanilla-editar";
import TipoPlanillaService from "services/TipoPlanillaService";
import { notification } from "antd";

const EditarTipoPlanillaPage =()=>{

    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [tipoPlanilla]=useAtom(atoms.tipoPlanillaAtom);
    const cerrarModalConfirmacion = useModalConfirmar(state => state.cerrarModal);

    const onClickRetornarListarTipoPlanillas=()=>{
        history.push("/tipoPlanilla");
    }
    const onClickBtnCancelarModal=()=>{
        cerrarModalConfirmacion();
    }
    const onClickBtnConfirmarModal = async ()=>{
        try {
            setLoading(true);
            const _tipoPlanilla= await TipoPlanillaService.actualizar(tipoPlanilla);
            setLoading(false);
            cerrarModalConfirmacion();
            history.push("/tipoPlanilla");
            
        } catch (error) {
            console.error(error);
            cerrarModalConfirmacion();
            notification.error({
                message:"Error",
                description:error.response.data.mensaje});
            
        }finally{
            setLoading(false);
        }

    }
    return(
        <Container titulo="Editar Tipo Planilla" onClickRetornar={onClickRetornarListarTipoPlanillas}>
         <TipoPlanillaEditar/>
         <ModalConfirmar
                loading={loading}
                mensaje="¿Está seguro de actualizar tipo planilla? "
                onClickBtnCancelar={onClickBtnCancelarModal}
                onClickBtnConfirmar={onClickBtnConfirmarModal} />
        </Container>
    )

}
export default EditarTipoPlanillaPage;